/**
 * 功能入口模块：出海测算 / AI 财税
 * 这两个模块在小程序里是「入口卡片 + 外链跳转」形态，
 * 图标资源托管在服务器端（res.roadlinkglb.com），此处仅维护入口定义。
 *
 * - type: 'link'  -> 直接在新窗口打开 entry.url（如出海测算）
 * - type: 'token' -> 调用 openAiFinance()：先取 token 再跳转到 clawtax（如 AI 财税）
 */
export const entryList = [
  {
    id: 'overseas-cesuan',
    name: '出海测算',
    icon: '/res/icon/logo/测算图片.jpg',
    desc: '基于目标市场、行业与预算，一键测算出海成本、周期与合规要点，输出专属落地方案建议。',
    type: 'link',
    url: 'https://www.roadlinkglobal.com/#/destination',
    btn: '前往测算'
  },
  {
    id: 'ai-finance',
    name: 'AI 财税',
    icon: '/res/icon/logo/ai财税.jpg',
    desc: '面向跨境企业的智能财税助手，支持多国增值税/所得税计算、票据识别与合规预警。',
    type: 'token',
    btn: '进入助手'
  }
]
